/**
 * The case-study password is never stored as readable text. It's kept as character codes
 * scrambled with a key, and visitor input is scrambled the same way before comparing.
 *
 * To change the password, encode the new one in the browser console:
 *   [...'NewPassword'].map((c) => c.charCodeAt(0) ^ 42)
 * and paste the resulting numbers into ENCODED below.
 */
const KEY = 42;
const ENCODED = [121, 95, 65, 67, 65, 75, 94, 95, 106];

export function matchesCaseStudyPassword(input: string): boolean {
  const codes = [...input.trim()].map((c) => c.charCodeAt(0) ^ KEY);
  return codes.length === ENCODED.length && codes.every((code, i) => code === ENCODED[i]);
}
